"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortFieldToJSON = exports.SortFieldFromJSONTyped = exports.SortFieldFromJSON = exports.SortField = void 0;
/**
 * Enum for sort Fields
 * @export
 * @enum {string}
 */
var SortField;
(function (SortField) {
    SortField["ACCOUNTID"] = "ACCOUNT_ID";
    SortField["COMPANYNAME"] = "COMPANY_NAME";
    SortField["ADDRESS"] = "ADDRESS";
    SortField["ZIPCODE"] = "ZIP_CODE";
    SortField["CITY"] = "CITY";
    SortField["STATECODE"] = "STATE_CODE";
    SortField["MOUSIGNEDDATE"] = "MOU_SIGNED_DATE";
    SortField["CLOSEDREQUESTDATE"] = "CLOSED_REQUEST_DATE";
    SortField["CLOSEDDATE"] = "CLOSED_DATE";
})(SortField = exports.SortField || (exports.SortField = {}));
function SortFieldFromJSON(json) {
    return SortFieldFromJSONTyped(json, false);
}
exports.SortFieldFromJSON = SortFieldFromJSON;
function SortFieldFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SortFieldFromJSONTyped = SortFieldFromJSONTyped;
function SortFieldToJSON(value) {
    return value;
}
exports.SortFieldToJSON = SortFieldToJSON;
